import { wrapEmail, htmlEscape, paragraphsToHtml, ctaButton, heroImage, assertNoUnsubstitutedTokens } from './_shared.js';

export default {
  id: 'announcement',
  name: 'Announcement',
  description: 'Hero + headline + paragraph + optional CTA. News, launches, company updates.',
  slots: [
    { id: 'preheader',   label: 'Preview text', type: 'text', optional: true, maxLen: 140,
      hint: 'Shown next to the subject in mailbox previews (~90 chars). Falls back to the headline if blank.' },
    { id: 'hero',        label: 'Hero image URL', type: 'image', optional: true },
    { id: 'eyebrow',     label: 'Eyebrow label', type: 'text', optional: true, maxLen: 40,
      hint: 'Tiny uppercase label above the headline — e.g. "Announcement" or "Just launched".' },
    { id: 'headline',    label: 'Headline',     type: 'text', optional: false, maxLen: 80 },
    { id: 'subheading',  label: 'Subheading',   type: 'text', optional: true, maxLen: 160 },
    { id: 'body',        label: 'Body',         type: 'longtext', optional: false },
    { id: 'buttonLabel', label: 'Button label', type: 'text', optional: true, pairsWith: 'buttonUrl' },
    { id: 'buttonUrl',   label: 'Button URL',   type: 'url', optional: true, pairsWith: 'buttonLabel' },
  ],
  render(content, branding, footer, options) {
    const c = content || {};
    const ff = (branding && branding.fontFamily) || 'Arial';
    const accent = (branding && branding.primaryColour) || '#00897b';
    const hidden = new Set(c.slotsHidden || []);
    const inner = `
      ${!hidden.has('hero') && c.hero ? heroImage(c.hero, c.headline) : ''}
      ${!hidden.has('eyebrow') && c.eyebrow ? `<p style="margin: 0 0 8px; font-family: ${ff}, Helvetica, Arial, sans-serif; font-size: 12px; font-weight: 600; letter-spacing: 0.12em; text-transform: uppercase; color: ${htmlEscape(accent)};">${htmlEscape(c.eyebrow)}</p>` : ''}
      <h1 class="headline dark-text" style="margin: 0 0 12px; font-family: ${ff}, Helvetica, Arial, sans-serif; font-size: 30px; font-weight: 700; line-height: 1.2; letter-spacing: -0.015em; color: #111827;">${htmlEscape(c.headline || '')}</h1>
      ${!hidden.has('subheading') && c.subheading ? `<p class="dark-text" style="margin: 0 0 24px; font-family: ${ff}, Helvetica, Arial, sans-serif; font-size: 17px; line-height: 1.5; color: #4b5563;">${htmlEscape(c.subheading)}</p>` : ''}
      ${paragraphsToHtml(c.body, ff)}
      ${!hidden.has('buttonLabel') && c.buttonLabel && c.buttonUrl ? ctaButton(c.buttonLabel, c.buttonUrl, branding) : ''}
    `;
    const html = wrapEmail(inner, branding, footer, {
      ...options,
      preheader: c.preheader || c.subheading || c.headline,
    });
    assertNoUnsubstitutedTokens(html);
    return html;
  },
};
